import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const Logo: React.FC = () => {
  return (
    <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
      <NavLink to="/" className="flex items-center space-x-2">
        <img src="/assets/logo/favicon.png" alt="Hubvex" className="h-9 w-auto" />
        <span className="text-2xl font-bold text-gray-800">Hubvex Auth</span>
      </NavLink>
    </motion.div>
  );
};

export default Logo;